// extracted by mini-css-extract-plugin
export default {"root":"DVe8PMqy","wrapper":"qf1AWBli"};